import InternalExitTransactionsPage from '../../pages/Almoxarifado/transactions/InternalExitTransactionsPage'
import PrivateRoute from '../../components/PrivateRoute'
import ProductsPage from '../../pages/Almoxarifado/products/ProductPage'
import CreateProductPage from '../../pages/Almoxarifado/products/CreateProductPage'
import EditProductPage from '../../pages/Almoxarifado/products/EditProductPage'
import DetailsProductPage from '../../pages/Almoxarifado/products/DetailsProductPage'
import BrandsPage from '../../pages/Almoxarifado/products/brands/BrandsPage'
import EditBrandsPage from '../../pages/Almoxarifado/products/brands/EditBrandsPage'
import CreateBrandsPage from '../../pages/Almoxarifado/products/brands/CreateBrandsPage'
import GroupPage from '../../pages/Almoxarifado/products/groups/GroupPage'
import CreateGroupPage from '../../pages/Almoxarifado/products/groups/CreateGroupPage'
import EditGroupPage from '../../pages/Almoxarifado/products/groups/EditGroupPage'
import TypePage from '../../pages/Almoxarifado/products/types/TypePage'
import CreateTypePage from '../../pages/Almoxarifado/products/types/CreateTypePage'
import EditTypePage from '../../pages/Almoxarifado/products/types/EditTypePage'
import AttachGroupToTypePage from '../../pages/Almoxarifado/products/types/typesGroups/AttachGroupToTypePage'
import SuppliersPage from '../../pages/Almoxarifado/suppliers/SuppliersPage'
import CreateSupplierPage from '../../pages/Almoxarifado/suppliers/CreateSupplierPage'
import EditSupplierPage from '../../pages/Almoxarifado/suppliers/EditSupplierPage'
import DetailsSupplierPage from '../../pages/Almoxarifado/suppliers/DetailsSupplierPage'
import CreateSupplierAddressPage from '../../pages/Almoxarifado/suppliers/address/CreateSupplierAddressPage'
import EditSupplierAddressPage from '../../pages/Almoxarifado/suppliers/address/EditSupplierAddressPage'
import CreateSupplierContactPage from '../../pages/Almoxarifado/suppliers/contact/CreateSupplierContactPage'
import SupplierAddressDetailsPage from '../../pages/Almoxarifado/suppliers/address/SupplierAddressDetailsPage'
import EditSupplierContactPage from '../../pages/Almoxarifado/suppliers/contact/EditSupplierContactPage'
import SupplierContactDetailsPage from '../../pages/Almoxarifado/suppliers/contact/SupplierContactDetailsPage'
import CreateTransactionPage from '../../pages/Almoxarifado/transactions/CreateTransactionPage'
import DetailsTransactionPage from '../../pages/Almoxarifado/transactions/DetailsTransactionPage'
import EditTransactionPage from '../../pages/Almoxarifado/transactions/EditTransactionPage'
import EntranceTransactionsPage from '../../pages/Almoxarifado/transactions/EntranceTransactionsPage'
import TransferTransactionPage from '../../pages/Almoxarifado/transactions/TransferTransactionPage'
import TransactionsReport from '../../pages/Relatorios/TransactionsReport/TransactionsReport'
import AccountingReport from '../../pages/Relatorios/Accounting/AccountingReport'
import InventoryReport from '../../pages/Relatorios/Inventory/Inventory'
import ProductExtractReport from '../../pages/Relatorios/ProductExtract/ProductExtract'
import StockControlCardReport from '../../pages/Relatorios/StockControlCard/StockControlCard'
import MonthlyAverageConsumptionReport from '../../pages/Relatorios/MonthlyAverageConsumption/MonthlyAverageConsumption'
import CreateInternalExitPage from '../../pages/Almoxarifado/transactions/CreateInternalExitPage'
import CriticalStockReport from '../../pages/Relatorios/CriticalStock/CriticalStock'

const RoutesAlmoxarifado = {
  products: [
    {
      path: '/almoxarifado/produtos',
      element: <PrivateRoute element={ProductsPage} />,
    },
    {
      path: '/almoxarifado/produtos/criar',
      element: <PrivateRoute element={CreateProductPage} />,
    },
    {
      path: '/almoxarifado/produtos/editar/:id',
      element: <PrivateRoute element={EditProductPage} />,
    },
    {
      path: '/almoxarifado/produtos/detalhes/:id',
      element: <PrivateRoute element={DetailsProductPage} />,
    },
    // * Marcas
    {
      path: '/almoxarifado/produtos/marcas',
      element: <PrivateRoute element={BrandsPage} />,
    },
    {
      path: '/almoxarifado/produtos/marcas/criar',
      element: <PrivateRoute element={CreateBrandsPage} />,
    },
    {
      path: '/almoxarifado/produtos/marcas/editar/:id',
      element: <PrivateRoute element={EditBrandsPage} />,
    },
    // * Grupos
    {
      path: '/almoxarifado/produtos/grupos',
      element: <PrivateRoute element={GroupPage} />,
    },
    {
      path: '/almoxarifado/produtos/grupos/criar',
      element: <PrivateRoute element={CreateGroupPage} />,
    },
    {
      path: '/almoxarifado/produtos/grupos/editar/:id',
      element: <PrivateRoute element={EditGroupPage} />,
    },
    // * Tipos
    {
      path: '/almoxarifado/produtos/tipos',
      element: <PrivateRoute element={TypePage} />,
    },
    {
      path: '/almoxarifado/produtos/tipos/criar',
      element: <PrivateRoute element={CreateTypePage} />,
    },
    {
      path: '/almoxarifado/produtos/tipos/editar/:id',
      element: <PrivateRoute element={EditTypePage} />,
    },
    {
      path: '/almoxarifado/produtos/tipos/associar-grupos/:id',
      element: <PrivateRoute element={AttachGroupToTypePage} />,
    },
  ],
  suppliers: [
    {
      path: '/almoxarifado/fornecedores',
      element: <PrivateRoute element={SuppliersPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/criar',
      element: <PrivateRoute element={CreateSupplierPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/editar/:id',
      element: <PrivateRoute element={EditSupplierPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/detalhes/:id',
      element: <PrivateRoute element={DetailsSupplierPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/:id/endereco/adicionar',
      element: <PrivateRoute element={CreateSupplierAddressPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/:id/endereco/:addressId/editar',
      element: <PrivateRoute element={EditSupplierAddressPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/:id/endereco/:addressId/detalhes',
      element: <PrivateRoute element={SupplierAddressDetailsPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/:id/contato/adicionar',
      element: <PrivateRoute element={CreateSupplierContactPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/:id/contato/editar/:contactId',
      element: <PrivateRoute element={EditSupplierContactPage} />,
    },
    {
      path: '/almoxarifado/fornecedores/:id/contato/:contactId/detalhes',
      element: <PrivateRoute element={SupplierContactDetailsPage} />,
    },
  ],
    transactions: [
    // * Entrada
    {
      path: '/almoxarifado/transacoes/entrada',
      element: <PrivateRoute element={EntranceTransactionsPage} />,
    },
    // * Transferência
    {
      path: '/almoxarifado/transacoes/transferencia',
      element: <PrivateRoute element={TransferTransactionPage} />,
    },
    // * Saida Interna - LISTA
    {
      path: '/almoxarifado/transacoes/saida-interna',
      element: <PrivateRoute element={InternalExitTransactionsPage} />,
    },
    // * Saida Interna - CRIAÇÃO
    {
      path: '/almoxarifado/transacoes/saida-interna/criar',
      element: <PrivateRoute element={CreateInternalExitPage} />,
    },
    // * CRUD genérico de transações
    {
      path: '/almoxarifado/transacoes/criar',
      element: <PrivateRoute element={CreateTransactionPage} />,
    },
    {
      path: '/almoxarifado/transacoes/editar/:id',
      element: <PrivateRoute element={EditTransactionPage} />,
    },
    {
      path: '/almoxarifado/transacoes/detalhes/:id',
      element: <PrivateRoute element={DetailsTransactionPage} />,
    },
  ],
  reports: [
    {
      path: '/almoxarifado/relatorios/transações',
      element: <PrivateRoute element={TransactionsReport} />,
    },
    {
      path: '/almoxarifado/relatorios/contabil',
      element: <PrivateRoute element={AccountingReport} />,
    },
    {
      path: '/almoxarifado/relatorios/inventario',
      element: <PrivateRoute element={InventoryReport} />,
    },
    {
      path: '/almoxarifado/relatorios/extrato-de-produto',
      element: <PrivateRoute element={ProductExtractReport} />,
    },
    {
      path: '/almoxarifado/relatorios/ficha-de-estoque',
      element: <PrivateRoute element={StockControlCardReport} />,
    },
    {
      path: '/almoxarifado/relatorios/consumo-mensal',
      element: <PrivateRoute element={MonthlyAverageConsumptionReport} />,
    },
    {
      path: '/almoxarifado/relatorios/estoque-critico',
      element: <PrivateRoute element={CriticalStockReport} />,
    },
  ],
}

export default RoutesAlmoxarifado
